<template>
  <div>
    <textarea :id="id"></textarea>
  </div>
</template>

<script>
  import https from '@/https.js';
  export default {
    name: 'ckeditor4',
    props: [
      'value'
    ],
    mounted: function() {
      const self = this
      this.ckeditor = CKEDITOR.replace(self.id, self.editorConfig);
      this.ckeditor.setData(self.value)
      this.ckeditor.on('change', function() {
        self.$emit('input', self.ckeditor.getData())
      })
    },
    data: function() {
      return {
        id: parseInt(Math.random() * 10000).toString(),
        ckeditor: null,
        editorConfig: {
          filebrowserUploadUrl: '',
          forcePasteAsPlainText: false,
          height: 300,
          fileTools_requestHeaders: {
            'X-Requested-With': 'XMLHttpRequest',
            Authentication: localStorage.getItem("token")
          }
        }
      }
    },
    watch: {
      value: function() {
        if (this.value !== this.ckeditor.getData()) {
          this.ckeditor.setData(this.value)
        }
      }
    },
    created: function() {
      this.editorConfig.filebrowserUploadUrl = this.https.baseURL+"/managerFile/fileupload";
    },
  }
</script>
